import { Fragment } from 'react';

import { formatHours } from './helpers';
import type { TeamCellProps } from './types';

// Who holds the client's hours, read at a glance; changing them is the plan's job.
export function TeamCell({ row }: TeamCellProps) {
  const holders = [
    ...row.plan.team.map((s) => ({
      key: s.userId,
      name: s.name,
      hours: s.fixedHours + s.variableHours,
    })),
    { key: 'cfo', name: 'CFO', hours: row.plan.cfoFixed + row.plan.cfoVariable },
  ];

  return (
    <span
      data-testid="client-team"
      className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-sm"
    >
      {holders.map((h, i) => (
        <Fragment key={h.key}>
          {i > 0 && <span className="text-text-tertiary">·</span>}
          <span className="whitespace-nowrap">
            <span className="text-text-primary">{h.name}</span>{' '}
            <span className="tabular-nums text-text-secondary">{formatHours(h.hours)}</span>
          </span>
        </Fragment>
      ))}
    </span>
  );
}
